class PricingBox {
  constructor(container) {
    this.container = container;
    this.state = container.dataset.pricingBoxState;
    this.introActive = container.hasAttribute('data-pricing-box-intro');
  }

  init() {
    this.radios = [...this.container.querySelectorAll('[data-pricing-box-radio]')];
    this.divider = this.container.querySelector('[data-pricing-box-divider-target]');
    this.trust = this.container.querySelector('[data-pricing-box-trust]');
    this.cta = this.container.querySelector('[data-pricing-box-cta]');
    this.ctaSuffix = this.cta ? this.cta.querySelector('[data-pricing-box-cta-suffix]') : null;
    this.mode = null;

    this.radios.forEach(radio => {
      radio.addEventListener('change', () => this.apply(radio));
    });

    if (this.cta) {
      this.cta.addEventListener('click', () => {
        if (this.mode !== 'mixmatch') return;
        const addPackage = document.querySelector(
          '.mix-and-match-popup .mix-and-match-popup-button.mix-and-match-add-package-to-cart'
        );
        addPackage?.click();
      });
    }

    const checked = this.radios.find(radio => radio.checked);
    if (checked) this.apply(checked);
  }

  apply(radio) {
    const { pricingBoxDivider, pricingBoxCtaSuffix, pricingBoxTrustSet, pricingBoxMode } = radio.dataset;
    this.mode = pricingBoxMode;

    if (this.divider && pricingBoxDivider) this.divider.textContent = pricingBoxDivider;
    if (this.ctaSuffix && pricingBoxCtaSuffix) this.ctaSuffix.textContent = pricingBoxCtaSuffix;
    if (this.trust && pricingBoxTrustSet) {
      this.trust.dataset.active = pricingBoxTrustSet;
      this.trust.querySelectorAll('[data-trust-set]').forEach(list => {
        list.classList.toggle('is-active', list.dataset.trustSet === pricingBoxTrustSet);
      });
    }

    if (this.cta) {
      if (radio.value) this.cta.setAttribute('variant_id', radio.value);
      this.cta.classList.toggle('subscription-atc-button', pricingBoxMode === 'regular' || pricingBoxMode === 'intro');
      this.cta.classList.toggle('single-atc-button', pricingBoxMode === 'onetime');
    }

    const mixMatch = this.container.querySelector('.mix-and-match');
    if (mixMatch) mixMatch.classList.toggle('active', radio.classList.contains('mix-and-match-radio'));
  }
}

function bootPricingBox() {
  document.querySelectorAll('[data-pricing-box]').forEach(container => {
    const pricingBox = new PricingBox(container);
    pricingBox.init();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootPricingBox);
} else {
  bootPricingBox();
}

export default PricingBox;
